var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import { defaultScrollNumberProps } from './defaults';
import { SpanTag, ITag } from '../../Utils/AtomicTag';
var ScrollNumber = /** @class */ (function (_super) {
    __extends(ScrollNumber, _super);
    function ScrollNumber(props) {
        return _super.call(this, props) || this;
    }
    ScrollNumber.prototype.componentWillReceiveProps = function () {
        var prevNum = this.props.count;
        this.setState({
            prev: prevNum,
        });
    };
    ScrollNumber.prototype.getNumberArray = function (num) {
        return num
            ? num
                .toString()
                .split('')
                .map(function (i) {
                var current = Number(i);
                return isNaN(current) ? i : current;
            })
            : [];
    };
    ScrollNumber.prototype.getNumberList = function (num) {
        if (typeof num === 'number') {
            var childRender = [];
            var childCls = ['not-italic', 'h-px-20', 'inline-block'];
            for (var i = 0; i < 10; i++) {
                childRender.push(React.createElement(ITag, { key: i, atomics: childCls }, i));
            }
            return childRender;
        }
        return num;
    };
    ScrollNumber.prototype.setTransStyle = function (num) {
        if (typeof num === 'number') {
            var transStyle = {
                msTransform: "translateY(" + -num * 100 + "%)",
                WebkitTransform: "translateY(" + -num * 100 + "%)",
                transform: "translateY(" + -num * 100 + "%)",
            };
            return transStyle;
        }
    };
    ScrollNumber.prototype.renderNumberElement = function () {
        var _this = this;
        var _a = this.props, count = _a.count, showZero = _a.showZero;
        var spanCls = [
            'flex',
            'flex-col',
            'transition-all',
            'duration-base',
            'ease-base-out',
        ];
        if (count && Number(count) % 1 === 0) {
            return this.getNumberArray(this.props.count).map(function (num, i) { return (React.createElement(SpanTag, { atomics: spanCls, key: i, style: _this.setTransStyle(num) }, _this.getNumberList(num))); });
        }
        if (count === 0 && !showZero)
            return this.state.prev;
        return count;
    };
    ScrollNumber.prototype.render = function () {
        return this.renderNumberElement();
    };
    ScrollNumber.defaultProps = defaultScrollNumberProps;
    return ScrollNumber;
}(PureComponent));
export { ScrollNumber };
